import React, { useState, useMemo } from "react";
import { formatDate } from "../../../../../utils/sharedFunctions";
import DeliverablesSection from "./../DeliverablesSection/DeliverablesSection.js";
import SkillsSection from "./../SkillsSection/SkillsSection.js";
import {
  TextInputDropdown,
  TextInput,
  AddData,
} from "../../../../../components";
import { MenuItem } from "@mui/material";

const AddIcon = `${process.env.REACT_APP_CDN_URL}/globalAssets/AddIcon.svg`;
const disabledAddbtn = `${process.env.REACT_APP_CDN_URL}/globalAssets/disabledAddbtn.svg`;
const downArrow = `${process.env.REACT_APP_CDN_URL}/globalAssets/briefview/downArrow.svg`;

const InfoTab = ({
  IsInfoEdit,
  SelectedBrief,
  Leads,
  professionals,
  newDeliverable,
  ExistingDeliverables,
  handleFinanceValuesChange,
  handleFulfilmentChange,
  setNewDeliverable,
  handleAddDeliverable,
  handleDeleteDeliverable,
  handleOfferingChange,
  handleContractTypeChange,
  handleLevelChange,
  handleWorkEnv,
  getAadditionalData,
  linkClickedFunc,
  linkClickedFunc2,
  LinkClicked,
  Message,
}) => {
  const [AddDataID, setAddDataID] = useState("");
  const isMigrated = SelectedBrief?.isMigrated === true;

  const data = useMemo(() => {
    const plan =
      SelectedBrief?.projectPlan?.[0] ??
      SelectedBrief?.brief?.projectPlan?.[0] ??
      SelectedBrief?.briefId?.projectPlan?.[0];

    return {
      fulfillmentLeadId:
        SelectedBrief?.fulfillmentLead?._id ??
        SelectedBrief?.fullfilmentLead?._id ??
        SelectedBrief?.talentPartner?._id ??
        "",
      fulfillmentLeadName: `${SelectedBrief?.fullfilmentLead?.firstName ?? SelectedBrief?.talentPartner?.firstName ?? ""} ${SelectedBrief?.fullfilmentLead?.lastName ?? SelectedBrief?.talentPartner?.lastName ?? ""}`,

      description:
        SelectedBrief?.briefDescription ??
        SelectedBrief?.projectBrief ??
        SelectedBrief?.brief?.briefDescription ??
        SelectedBrief?.description ??
        "",

      startDate: isMigrated
        ? SelectedBrief?.projectStartDate || SelectedBrief?.createdAt
        : plan?.projStartDate || new Date().toISOString(),

      endDate: isMigrated
        ? SelectedBrief?.projectEndDate || SelectedBrief?.createdAt
        : plan?.projEndDate || "",

      industry: SelectedBrief?.industry ?? SelectedBrief?.brief?.industry ?? "",
      location: SelectedBrief?.location ?? "Not Assigned",

      deliverables: plan?.deliverables || [],

      links: SelectedBrief?.projectLinks || [],

      skills:
        SelectedBrief?.briefId?.skillsOfProfessional ??
        SelectedBrief?.skillsOfProfessional ??
        [],

      serviceCategory:
        SelectedBrief?.serviceCategory ??
        SelectedBrief?.typeOfProfessional ??
        [],
    };
  }, [SelectedBrief, isMigrated]);

  const getAddDataID = (e) => {
    const ID = e.currentTarget.id;
    // Check if brief exists/linked (Logic preserved from original)
    if (ID === "prolink" && !SelectedBrief?.project) {
      Message({
        status: true,
        message: "Brief is not linked to any project!",
        type: "info",
        title: "Info",
      });
      return;
    }
    setAddDataID(ID);
  };

  // --- 2. FORMATTERS ---
  const normalize = (val) => (val || "").toLowerCase().trim();

  const getOffering = () => {
    const raw = Array.isArray(SelectedBrief?.servicesOffered)
      ? SelectedBrief.servicesOffered[0]
      : SelectedBrief?.servicesOffered;

    const map = {
      "talent access: retainer": "Talent Access: Retainer",
      "talent access: once off": "Talent Access: Once Off",
      "talent access: once-off": "Talent Access: Once Off",
      "talent partner: placement": "Talent Partner: Placement",
      "talent partner: team assembly": "Talent Partner: Team Assembly",
      "talent partner: voucher": "Talent Partner: Voucher",
      videography: "Videography",
      "rws: remote workplace simulation": "RWS: Remote workplace simulation",
    };
    return map[normalize(raw)] || raw || "Not Selected";
  };

  const getContractType = () => {
    const map = {
      "once-off": "Once-Off",
      "short-term placement": "Short-Term Placement",
      "fixed-term placement": "Fixed-Term Placement",
      "permanent placement": "Permanent Placement",
      ongoing: "Ongoing",
    };
    return (
      map[normalize(SelectedBrief?.contractType)] ||
      SelectedBrief?.contractType ||
      "Not Selected"
    );
  };

  const getExperienceLevel = () => {
    const map = {
      "entry level": "Entry Level",
      junior: "Junior",
      "junior-intermediate": "Junior-Intermediate",
      intermediate: "Intermediate",
      "intermediate-senior": "Intermediate-Senior",
      "intermediate/senior": "Intermediate-Senior",
      senior: "Senior",
    };
    return (
      map[normalize(SelectedBrief?.professionalExperienceLevel)] ||
      "Not Selected"
    );
  };

  const getWorkingEnvironment = () => {
    const val =
      SelectedBrief?.workingEnvironment ??
      SelectedBrief?.brief?.workingEnvironment;
    const map = {
      remote: "Remote",
      onsite: "Onsite",
      hybrid: "Hybrid",
    };
    return map[normalize(val)] || "Not Selected";
  };

  const renderDeliverablesList = () => {
    if (isMigrated) {
      return (
        <p className="noDataText">
          Detailed deliverables not available for historical data.
        </p>
      );
    }
    if (data.deliverables.length > 0) {
      return (
        <ul style={{ padding: "0px", margin: "1% 0%" }}>
          {data.deliverables.map((item, index) => (
            <li key={index} className="deliverableItem">
              {item.nameOfItem}
            </li>
          ))}
        </ul>
      );
    }
    return <p className="noDataText">No Deliverables</p>;
  };

  const renderServiceCategories = () => {
    const cats = Array.isArray(data.serviceCategory)
      ? data.serviceCategory
      : [data.serviceCategory];
    const validCats = cats.filter((c) => typeof c === "string" && c !== "");

    if (validCats.length > 0) {
      return validCats.map((item, index) => (
        <p
          key={index}
          className="mini_p_kids"
          style={{ fontSize: "12px", color: "#6D4194" }}
        >
          {item}
        </p>
      ));
    }
    return (
      <p className="noDataText" style={{ fontSize: "12px" }}>
        No Category Found
      </p>
    );
  };

  return IsInfoEdit ? (
    //  EDIT MODE 
    <div className="BriefInfoSection">
      {/* Left Section */}
      <div className="infoContainerSects">
        <TextInputDropdown
          style={{ width: "95%" }}
          placeholder="Talent Partner"
          label="Talent Partner"
          value={data.fulfillmentLeadId}
          onChange={handleFulfilmentChange}
        >
          {Leads.map((item) => (
            <MenuItem key={item._id} value={item._id}>
              {item.fullName || ""}
            </MenuItem>
          ))}
        </TextInputDropdown>

        <div className="briefInfo">
          <p className="header">Professional</p>
          <span>
            {/* Logic: Only allow adding pro if not already inside a brief structure or if explicit flag */}
            <img
              src={!SelectedBrief?.brief ? AddIcon : disabledAddbtn}
              alt="add professional"
              style={{ cursor: SelectedBrief?.brief ? "default" : "pointer" }}
              onClick={!SelectedBrief?.brief ? getAddDataID : null}
              id="addPro"
            />
          </span>
          {AddDataID === "addPro" && (
            <div className="transparentCover">
              <AddData
                style={{ padding: "1%", top: "40%", width: "25%", left: "22%" }}
                SelectedBrief={SelectedBrief}
                id="addPro"
                additionalData={professionals}
                InputType="menudropdown"
                getData={getAadditionalData}
                closeComponent={() => setAddDataID("")}
                MenuItems={professionals.map(
                  (item) => `${item.firstName} ${item.lastName}`
                )}
              />
            </div>
          )}
        </div>

        <div className="textAreacontainer" style={{ height: "73.6%" }}>
          <p style={{ fontWeight: 700, fontSize: "14px", lineHeight: "24px" }}>
            Description
          </p>
          <textarea
            id="Description"
            style={{ color: "#AFAFAF" }}
            value={data.description}
            onChange={handleFinanceValuesChange}
          />
        </div>
      </div>

      {/* Middle Section */}
      <div className="infoContainerSects">
        <TextInput
          style={{ width: "95%" }}
          placeholder="Start Date"
          label="Start Date"
          type="date"
          id="StartDate"
          value={formatDate(data.startDate).split("T")[0] || ""} // Ensure YYYY-MM-DD
          onChange={handleFinanceValuesChange}
        />
        <TextInput
          style={{ width: "95%" }}
          placeholder="End Date"
          label="End Date"
          type="date"
          id="EndDate"
          value={formatDate(data.endDate).split("T")[0] || ""}
          onChange={handleFinanceValuesChange}
        />

        <DeliverablesSection
          newDeliverable={newDeliverable}
          setNewDeliverable={setNewDeliverable}
          handleAddDeliverable={handleAddDeliverable}
          SelectedBrief={SelectedBrief}
          ExistingDeliverables={ExistingDeliverables}
          handleDeleteDeliverable={handleDeleteDeliverable}
        />
      </div>

      {/* Right Section */}
      <div className="infoContainerSects">
        <TextInput
          style={{ width: "95%" }}
          placeholder="Industry Category"
          label="Industry Category"
          id="Industry"
          value={data.industry}
          onChange={handleFinanceValuesChange}
        />
        <TextInput
          style={{ width: "95%" }}
          placeholder="Location"
          label="Location"
          id="Location"
          value={data.location}
          onChange={handleFinanceValuesChange}
        />

        <SkillsSection
          SelectedBrief={SelectedBrief}
          AddDataID={AddDataID}
          Message={Message}
          getAadditionalData={getAadditionalData}
          linkClickedFunc={linkClickedFunc}
          linkClickedFunc2={linkClickedFunc2}
          LinkClicked={LinkClicked}
        />
      </div>

      {/* Bottom Section */}
      <div
        className="offeringfSection"
        style={{ justifyContent: "space-around", alignItems: "center" }}
      >
        <TextInputDropdown
          style={{ width: "95%" }}
          placeholder="Offering"
          label="Offering"
          value={getOffering()}
          onChange={handleOfferingChange}
        >
          <MenuItem value="Talent Access: Retainer">
            Talent Access: Retainer
          </MenuItem>
          <MenuItem value="Talent Access: Once Off">
            Talent Access: Once Off
          </MenuItem>
          <MenuItem value="Talent Partner: Placement">
            Talent Partner: Placement
          </MenuItem>
          <MenuItem value="Talent Partner: Team Assembly">
            Talent Partner: Team Assembly
          </MenuItem>
          <MenuItem value="Talent Partner: Voucher">
            Talent Partner: Voucher
          </MenuItem>
          <MenuItem value="Videography">Videography</MenuItem>
          <MenuItem value="RWS: Remote workplace simulation">
            RWS: Remote workplace simulation
          </MenuItem>
        </TextInputDropdown>

        <TextInputDropdown
          style={{ width: "95%", marginTop: "0.6%" }}
          placeholder="Contract Type"
          label="Contract Type"
          value={getContractType()}
          onChange={handleContractTypeChange}
        >
          <MenuItem value="Once-Off">Once-Off</MenuItem>
          <MenuItem value="Short-Term Placement">Short-Term Placement</MenuItem>
          <MenuItem value="Fixed-Term Placement">Fixed-Term Placement</MenuItem>
          <MenuItem value="Permanent Placement">Permanent Placement</MenuItem>
          <MenuItem value="Ongoing">Ongoing</MenuItem>
        </TextInputDropdown>

        <TextInputDropdown
          style={{ width: "95%", marginTop: "3%" }}
          placeholder="Experience Level"
          label="Experience Level"
          value={getExperienceLevel()}
          onChange={handleLevelChange}
        >
          <MenuItem value="Entry Level">Entry Level</MenuItem>
          <MenuItem value="Junior">Junior</MenuItem>
          <MenuItem value="Junior-Intermediate">Junior-Intermediate</MenuItem>
          <MenuItem value="Intermediate">Intermediate</MenuItem>
          <MenuItem value="Intermediate-Senior">Intermediate-Senior</MenuItem>
          <MenuItem value="Senior">Senior</MenuItem>
        </TextInputDropdown>

        <TextInputDropdown
          style={{ width: "95%" }}
          placeholder="Working Environment"
          label="Working Environment"
          value={getWorkingEnvironment()}
          onChange={handleWorkEnv}
        >
          <MenuItem value="Remote">Remote</MenuItem>
          <MenuItem value="Onsite">Onsite</MenuItem>
          <MenuItem value="Hybrid">Hybrid</MenuItem>
        </TextInputDropdown>

        <div
          className="textAreacontainer"
          style={{
            maxHeight: "46%",
            width: "95%",
            padding: "0% 1%",
            justifyContent: "flex-end",
            position: "relative",
          }}
        >
          <p
            style={{ fontWeight: "700", fontSize: "14px", lineHeight: "24px" }}
            className="p_with_span_add"
          >
            Category of Service
            <span className="the_span">
              {!SelectedBrief?.brief && (
                <img
                  src={AddIcon}
                  alt="add icon"
                  id="catService"
                  onClick={getAddDataID}
                />
              )}
            </span>
          </p>
          {AddDataID === "catService" && (
            <AddData
              SelectedBrief={SelectedBrief}
              id="catservice"
              InputType="menudropdown"
              getData={getAadditionalData}
              closeComponent={() => {
                setAddDataID("");
              }}
              MenuItems={[
                "Design and Illustration",
                "Digital Marketing and Social Media",
                "Mobile and Web Development",
                "Photography and Videography",
                "Writing Services",
                "Other Services",
              ]}
            />
          )}

          <div className="minidisplaybox" style={{ marginBottom: "1%" }}>
            <div className="minidisplaybox_inner">
              {renderServiceCategories()}
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : (
    // VIEW MODE 
    <div className="BriefInfoSection">
      {/* Left Section */}
      <div className="infoContainerSects">
        <div className="briefInfo">
          <p className="header">Talent Partner</p>
          <p className="value">{data.fulfillmentLeadName}</p>
        </div>
        <div className="briefInfo" style={{ position: "relative" }}>
          <p className="header">Professional</p>
          <span>
            <img src={disabledAddbtn} alt="disabled add button" id="addPro" />
          </span>
        </div>
        <div className="briefDescBox">
          <p className="header">Description</p>
          <div className="descriptionSection">
            <p style={{ color: "#AFAFAF" }}>
              {data.description || (
                <span className="noDataText">No Description</span>
              )}
            </p>
          </div>
        </div>
      </div>

      {/* Middle Section */}
      <div className="infoContainerSects">
        <div className="briefInfo">
          <p className="header">Start Date</p>
          <p className="value">
            {data.startDate ? formatDate(data.startDate) : "No Start Date"}
          </p>
        </div>
        <div className="briefInfo">
          <p className="header">End Date</p>
          <p className="value">
            {data.endDate ? formatDate(data.endDate) : "No End Date"}
          </p>
        </div>
        <div className="briefDescBox">
          <p className="header">Deliverables & Responsibilities</p>
          <div className="descriptionSection">{renderDeliverablesList()}</div>
        </div>
      </div>

      {/* Right Section */}
      <div className="infoContainerSects">
        <div className="briefInfo">
          <p className="header">Industry Category</p>
          <p className="value">{data.industry || "Not Assigned"}</p>
        </div>
        <div className="briefInfo">
          <p className="header">Location</p>
          <p className="value">{data.location}</p>
        </div>

        {/* Project Links */}
        <div
          className="textAreacontainer"
          style={{
            maxHeight: "37%",
            width: "95%",
            padding: "0% 1% 1% 1%",
            position: "relative",
          }}
        >
          <p
            style={{ fontWeight: "700", fontSize: "14px", lineHeight: "24px" }}
            className="p_with_span_add"
          >
            Project Links
          </p>
          <div className="minidisplaybox">
            <div className="minidisplaybox_inner">
              {data.links.length > 0 ? (
                data.links.map((item, index) =>
                  item?.url ? (
                    <p
                      key={index}
                      onMouseUp={linkClickedFunc2}
                      onMouseDown={linkClickedFunc}
                      className="mini_p_kids"
                      style={{
                        fontSize: "12px",
                        color: LinkClicked ? "#6D4194" : "",
                      }}
                    >
                      {item.url}
                    </p>
                  ) : null
                )
              ) : (
                <p className="noDataText" style={{ fontSize: "12px" }}>
                  No Links Found
                </p>
              )}
            </div>
          </div>
        </div>

        {/* Skills */}
        <div
          className="textAreacontainer"
          style={{
            maxHeight: "37%",
            width: "95%",
            padding: "0% 1% ",
            position: "relative",
          }}
        >
          <p
            style={{ fontWeight: "700", fontSize: "14px", lineHeight: "24px" }}
            className="p_with_span_add"
          >
            Skills Of Professional
          </p>
          <div className="minidisplaybox" style={{ overflow: "hidden" }}>
            <div className="minidisplaybox_inner">
              {data.skills.length > 0 ? (
                data.skills.map((item, index) => (
                  <p
                    key={index}
                    className="mini_p_kids"
                    style={{ fontSize: "12px" }}
                  >
                    {item}
                  </p>
                ))
              ) : (
                <p className="noDataText" style={{ fontSize: "12px" }}>
                  No Skills Found
                </p>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Section */}
      <div className="offeringfSection">
        <div className="Section">
          <p className="header">Offering</p>
          <div className="offeringSec">
            <p className="value">{getOffering()}</p>
            <img src={downArrow} alt="dropdown" />
          </div>
        </div>
        <div className="Section">
          <p className="header">Contract Type</p>
          <div className="offeringSec">
            <p className="value">{getContractType()}</p>
            <img src={downArrow} alt="dropdown" />
          </div>
        </div>
        <div className="Section">
          <p className="header">Experience Level</p>
          <div className="offeringSec">
            <p className="value">{getExperienceLevel()}</p>
            <img src={downArrow} alt="dropdown" />
          </div>
        </div>
        <div className="Section">
          <p className="header">Working Environment</p>
          <div className="offeringSec">
            <p className="value">{getWorkingEnvironment()}</p>
            <img src={downArrow} alt="dropdown" />
          </div>
        </div>
        <div
          className="textAreacontainer"
          style={{
            maxHeight: "46%",
            width: "95%",
            padding: "0% 1%",
            justifyContent: "flex-end",
            position: "relative",
            left: "2.5%",
          }}
        >
          <p
            style={{ fontWeight: "700", fontSize: "14px", lineHeight: "24px" }}
            className="p_with_span_add"
          >
            Category of Service
          </p>
          <div className="minidisplaybox" style={{ marginBottom: "0%" }}>
            <div className="minidisplaybox_inner">
              {renderServiceCategories()}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InfoTab;
